const baseStyle = {
  filledTrack: {
    bg: "primary"
  },
  track: {
    w: "100%",
    h: "4px",
    bg: "lowEmphasis"
  }
};

export default {
  baseStyle
};
